<template>
  <div class="view">
    <div class="header-container">
      <div class="view-gabarit">
        <h2>{{ $t('exportSection.header') }}</h2>
      </div>
    </div>
    <div class="form-container">
      <div class="view-gabarit">
        <div class="view-content">
          <div class="details-box">
            <h3>{{ pagination }}. {{ $t('exportSection.sectionsTitle') }}</h3>
            <p class="baseline">{{ $t('exportSection.sectionsBaseline') }}</p>
          </div>
          <div class="form-gabarit">
            <div class="form-block">
              <div class="fieldset">
                <fieldset v-for="(section, idx) in currentExport.sections" :key="idx" class="site-gabarit">
                  <input :id="`section-${idx}`" v-model="section.enabled" type="checkbox" />
                  <label :for="`section-${idx}`">
                    <b>{{ $t(`sections.${section.value}`) }}</b>
                  </label>
                  <div v-if="section.value === 'transit'" class="option-container" :class="{ disabled: !section.enabled }">
                    <div class="option" :class="{ selected: !collaboratorsByTimeRangesMode }" @click="collaboratorsByTimeRangesMode = false">
                      <div class="radio-button"></div>
                      <div class="label">{{ $t('exportSection.transitGraphSimple') }}</div>
                    </div>
                    <div class="option" :class="{ selected: collaboratorsByTimeRangesMode }" @click="collaboratorsByTimeRangesMode = true">
                      <div class="radio-button"></div>
                      <div class="label">{{ $t('exportSection.transitGraphAdvenced') }}</div>
                    </div>
                  </div>
                  <div v-if="section.value === 'environmental'" class="option-container" :class="{ disabled: !section.enabled }">
                    <div class="option" :class="{ selected: environmentalMode === 1 }" @click="environmentalMode = 1">
                      <div class="radio-button"></div>
                      <div class="label">{{ $t('sections.byJourney') }}</div>
                    </div>
                    <div class="option" :class="{ selected: environmentalMode === 0 }" @click="environmentalMode = 0">
                      <div class="radio-button"></div>
                      <div class="label">{{ $t('sections.byYear') }}</div>
                    </div>
                    <div class="option" :class="{ selected: environmentalMode === 2 }" @click="environmentalMode = 2">
                      <div class="radio-button"></div>
                      <div class="label">{{ $t('sections.byYearWeighted') }}</div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="view-gabarit">
        <div class="cta-container">
          <button class="study-button" @click="() => previousStep()">
            {{ $t('previous') }}
          </button>
          <button class="study-button main" @click="() => nextStep()">
            {{ $t('previewYourExport') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ExportType from '@/pure/ExportType';

export default {
  data() {
    return {
      environmentalMode: 0,
      collaboratorsByTimeRangesMode: false,
    };
  },

  computed: {
    ...mapGetters(['currentExport']),

    pagination() {
      return this.currentExport.type === ExportType.Simplified ? 3 : 4;
    },
  },

  created() {
    this.environmentalMode = this.currentExport.environmental_mode;
    this.collaboratorsByTimeRangesMode = this.currentExport.collaborators_by_time_ranges_mode;
  },

  methods: {
    getActiveSections() {
      return this.currentExport.sections.filter(section => section.enabled).map(section => section.value);
    },

    previousStep() {
      this.$router.push({ name: 'exportTransportMode' });
    },

    nextStep() {
      const id = this.$route.params.studyId;
      const payload = {
        sections: this.getActiveSections(),
        environmental_mode: this.environmentalMode,
        collaborators_by_time_ranges_mode: this.collaboratorsByTimeRangesMode,
        status: 5,
      };

      this.$store.dispatch('patchExport', { id, payload }).then(() => {
        this.$router.push({ name: 'exportConfiguration' });
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.option-container {
  margin: 4px 0 2px 26px;
  padding: 2px 0;
  transition: 0.2s;

  .option {
    display: flex;
    align-items: center;
    margin: 8px 0;
    cursor: pointer;

    .radio-button {
      $radius: 16px;
      position: relative;
      width: $radius;
      height: $radius;
      border-radius: $radius;
      border: solid 1px colors.$nude-concrete-color;
      margin: 2px 4px 0 0;
      box-sizing: border-box;
      transition: 0.2s;

      &::after {
        content: '';
        position: absolute;
        $padding: 2px;
        top: $padding;
        right: $padding;
        bottom: $padding;
        left: $padding;
        background: colors.$navy-color;
        border-radius: $radius;
        transform: scale(0);
        opacity: 0;
        transition: 0.2s ease-out;
      }
    }

    .label {
      color: colors.$near-dark-color;
    }

    &.selected {
      .radio-button {
        border-color: colors.$navy-color;

        &::after {
          opacity: 1;
          transform: scale(1);
        }
      }
    }

    &:hover {
      .radio-button {
        border-color: colors.$navy-color;
      }
    }
  }

  &.disabled {
    opacity: 0.4;
    pointer-events: none;

    .option {
      .radio-button {
        &::after {
          background: colors.$nude-concrete-color;
        }
      }
    }
  }
}
</style>
